module.exports = __webpack_public_path__ + "img/resetpassword1.bb654e4.png";